import {type FC, useMemo} from 'react';

import {useI18n} from '@yourcoach/i18n';

import type {CourseExpandedCommon} from '../../../../api/course';

import CheckSVG from '../../../../assets/icons/check.svg';
import {CourseModel} from '../../../../utils/entity/course/createCourseModel';
import {platform} from '../../../../utils/platform';
import {CourseListItemJSX} from '../../components/CourseListItem';

type Props = {
  course: CourseExpandedCommon;
  onClick?: (course: CourseExpandedCommon) => void;
};

export const ClientIndividualCourseListItem: FC<Props> = ({
  course,
  onClick,
}) => {
  const {t} = useI18n();
  const model = useMemo(() => new CourseModel(course), [course]);

  const getStatus = () => {
    if (model.isArchived) {
      return undefined;
    }

    return platform.isNative ? t('shared:joined') : model.statusString;
  };

  return (
    <CourseListItemJSX
      buttons={
        model.isArchived || platform.isNative
          ? []
          : [
              {
                disabled: true,
                icon: CheckSVG,
                iconColor: 'global2',
                scheme: 'secondary-light',
                text: t('shared:joined'),
              },
            ]
      }
      isArchived={model.isArchived}
      onClick={() => onClick?.(course)}
      status={getStatus()}
      title={model.label}
    />
  );
};
